/**
 * @generated SignedSource<<7f04d37cdf4ad0ede96174e6b4a88306>>
 * @relayHash 220e81da920208aff34e40582f078295
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5a83ff1206bb8bcee263f8c6ac3a2b5fe6fce5cb1e3693af05a243470e999487

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CatchupContentType = "BLOGPOST" | "PAGE" | "%future added value";
export type ViewPagePersonalizationQuery$variables = {
  catchupContentType: CatchupContentType;
  cloudId: string;
  contentId: string;
  includeAIFloatingContextMenu?: boolean | null;
  includeLoom?: boolean | null;
  includeMeetingRecorderEligibility: boolean;
  includeOnboardingState?: boolean | null;
  includePresenceSettings?: boolean | null;
  includeRecommendations?: boolean | null;
  onboardingKeys?: ReadonlyArray<string | null> | null;
  recommendationEntityType: string;
  recommendationExperience: string;
  recommendationSpaceId: string;
  spaceKey: string;
};
export type ViewPagePersonalizationQuery$data = {
  readonly catchupGetLastViewedTime?: {
    readonly " $fragmentSpreads": FragmentRefs<"useDynamicSplitButton_catchupLastViewedTimeReader">;
  } | null;
  readonly confluence_teamPresenceContentSetting?: {
    readonly " $fragmentSpreads": FragmentRefs<"ContentHeaderPresence_contentSettingReader">;
  } | null;
  readonly getRecommendedPages?: {
    readonly " $fragmentSpreads": FragmentRefs<"EndOfPageRecommendation_recommendedPagesReader">;
  } | null;
  readonly getRecommendedPagesSpaceStatus?: {
    readonly " $fragmentSpreads": FragmentRefs<"EndOfPageRecommendation_spaceStatusReader">;
  } | null;
  readonly loom?: {
    readonly " $fragmentSpreads": FragmentRefs<"loomPersonalization_entryPoints" | "loomPersonalization_tenant">;
  } | null;
  readonly onboardingState?: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"onboardingState_state">;
  }> | null;
  readonly space?: {
    readonly id: string | null;
  } | null;
};
export type ViewPagePersonalizationQuery = {
  response: ViewPagePersonalizationQuery$data;
  variables: ViewPagePersonalizationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "catchupContentType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAIFloatingContextMenu"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeLoom"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeMeetingRecorderEligibility"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeOnboardingState"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includePresenceSettings"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRecommendations"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "onboardingKeys"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recommendationEntityType"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recommendationExperience"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recommendationSpaceId"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v14 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v15 = {
  "args": [
    (v14/*: any*/)
  ],
  "concreteType": "ConfluenceLoomEntryPoints",
  "kind": "LinkedField",
  "name": "confluence_loomEntryPoints",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isLoomEntryPointsEnabled"
    }
  ]
},
v16 = [
  {
    "kind": "Variable",
    "name": "siteId",
    "variableName": "cloudId"
  }
],
v17 = {
  "condition": "includeMeetingRecorderEligibility",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": (v16/*: any*/),
      "concreteType": "LoomSettings",
      "kind": "LinkedField",
      "name": "loom_settings",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "meetingRecordingsAvailable"
        },
        {
          "kind": "ScalarField",
          "name": "meetingNotesEligible"
        }
      ]
    },
    {
      "args": (v16/*: any*/),
      "concreteType": "LoomConnectedCalendar",
      "kind": "LinkedField",
      "name": "loom_connectedCalendars",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "guid"
        }
      ]
    }
  ]
},
v18 = {
  "concreteType": "ConfluenceTenantContext",
  "kind": "LinkedField",
  "name": "confluence_tenantContext",
  "plural": false,
  "selections": [
    {
      "concreteType": "LicensedProduct",
      "kind": "LinkedField",
      "name": "licensedProducts",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "licenseStatus"
        },
        {
          "kind": "ScalarField",
          "name": "productKey"
        }
      ]
    }
  ]
},
v19 = {
  "kind": "ScalarField",
  "name": "id"
},
v20 = {
  "args": [
    {
      "kind": "Variable",
      "name": "key",
      "variableName": "spaceKey"
    }
  ],
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v19/*: any*/)
  ]
},
v21 = [
  {
    "kind": "Variable",
    "name": "entityId",
    "variableName": "contentId"
  },
  {
    "kind": "Variable",
    "name": "entityType",
    "variableName": "recommendationEntityType"
  },
  {
    "kind": "Variable",
    "name": "experience",
    "variableName": "recommendationExperience"
  }
],
v22 = [
  {
    "kind": "Variable",
    "name": "entityId",
    "variableName": "recommendationSpaceId"
  }
],
v23 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "onboardingKeys"
  }
],
v24 = [
  {
    "kind": "Variable",
    "name": "contentId",
    "variableName": "contentId"
  },
  {
    "kind": "Variable",
    "name": "contentType",
    "variableName": "catchupContentType"
  }
],
v25 = [
  (v14/*: any*/),
  {
    "kind": "Variable",
    "name": "spaceKey",
    "variableName": "spaceKey"
  }
],
v26 = {
  "kind": "ScalarField",
  "name": "key"
},
v27 = {
  "kind": "ScalarField",
  "name": "value"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": {
      "throwOnFieldError": true
    },
    "name": "ViewPagePersonalizationQuery",
    "selections": [
      {
        "condition": "includeLoom",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "loomPersonalization_entryPoints",
                  "selections": [
                    (v15/*: any*/),
                    (v17/*: any*/)
                  ],
                  "argumentDefinitions": [
                    {
                      "kind": "RootArgument",
                      "name": "cloudId"
                    },
                    {
                      "kind": "RootArgument",
                      "name": "includeMeetingRecorderEligibility"
                    }
                  ]
                },
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "loomPersonalization_tenant",
                  "selections": [
                    (v18/*: any*/)
                  ],
                  "argumentDefinitions": []
                }
              ]
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "loom"
          }
        ]
      },
      {
        "condition": "includeRecommendations",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v20/*: any*/),
          {
            "args": (v21/*: any*/),
            "concreteType": "RecommendedPages",
            "kind": "LinkedField",
            "name": "getRecommendedPages",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "EndOfPageRecommendation_recommendedPagesReader"
              }
            ]
          },
          {
            "args": (v22/*: any*/),
            "concreteType": "RecommendedPagesSpaceStatus",
            "kind": "LinkedField",
            "name": "getRecommendedPagesSpaceStatus",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "EndOfPageRecommendation_spaceStatusReader"
              }
            ]
          }
        ]
      },
      {
        "condition": "includeOnboardingState",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v23/*: any*/),
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "onboardingState_state"
              }
            ]
          }
        ]
      },
      {
        "condition": "includeAIFloatingContextMenu",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v24/*: any*/),
            "concreteType": "CatchupLastViewedTimeResponse",
            "kind": "LinkedField",
            "name": "catchupGetLastViewedTime",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "useDynamicSplitButton_catchupLastViewedTimeReader"
              }
            ]
          }
        ]
      },
      {
        "condition": "includePresenceSettings",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v25/*: any*/),
            "concreteType": "ConfluenceTeamPresence",
            "kind": "LinkedField",
            "name": "confluence_teamPresenceContentSetting",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "ContentHeaderPresence_contentSettingReader"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v13/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "ViewPagePersonalizationQuery",
    "selections": [
      {
        "condition": "includeLoom",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v15/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/)
        ]
      },
      {
        "condition": "includeRecommendations",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v20/*: any*/),
          {
            "args": (v21/*: any*/),
            "concreteType": "RecommendedPages",
            "kind": "LinkedField",
            "name": "getRecommendedPages",
            "plural": false,
            "selections": [
              {
                "concreteType": "RecommendedPagesItem",
                "kind": "LinkedField",
                "name": "recommendedPages",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "title"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "type"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "subType"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "creatorId"
                      },
                      {
                        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "webui"
                          }
                        ]
                      },
                      {
                        "concreteType": "History",
                        "kind": "LinkedField",
                        "name": "history",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "ownedBy",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__typename"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "displayName"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v26/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          }
                        ]
                      },
                      {
                        "alias": "emoji",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "key",
                            "value": "emoji-title-published"
                          }
                        ],
                        "concreteType": "PaginatedJsonContentPropertyList",
                        "kind": "LinkedField",
                        "name": "properties",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              (v19/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/)
                            ]
                          }
                        ],
                        "storageKey": "properties(key:\"emoji-title-published\")"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "strategy"
                  }
                ]
              }
            ]
          },
          {
            "args": (v22/*: any*/),
            "concreteType": "RecommendedPagesSpaceStatus",
            "kind": "LinkedField",
            "name": "getRecommendedPagesSpaceStatus",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "recommendedPagesEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "defaultBehavior"
              }
            ]
          }
        ]
      },
      {
        "condition": "includeOnboardingState",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v23/*: any*/),
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
              (v26/*: any*/),
              (v27/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "includeAIFloatingContextMenu",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v24/*: any*/),
            "concreteType": "CatchupLastViewedTimeResponse",
            "kind": "LinkedField",
            "name": "catchupGetLastViewedTime",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "lastViewedTimeISO"
              }
            ]
          }
        ]
      },
      {
        "condition": "includePresenceSettings",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v25/*: any*/),
            "concreteType": "ConfluenceTeamPresence",
            "kind": "LinkedField",
            "name": "confluence_teamPresenceContentSetting",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isEnabledOnContentView"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "220e81da920208aff34e40582f078295",
    "id": "5a83ff1206bb8bcee263f8c6ac3a2b5fe6fce5cb1e3693af05a243470e999487",
    "metadata": {},
    "name": "ViewPagePersonalizationQuery",
    "operationKind": "query",
    "text": "query ViewPagePersonalizationQuery($contentId:ID!,$spaceKey:String!,$cloudId:ID!,$catchupContentType:CatchupContentType!,$recommendationEntityType:String!,$recommendationExperience:String!,$recommendationSpaceId:ID!,$onboardingKeys:[String],$includeRecommendations:Boolean=false,$includeOnboardingState:Boolean=false,$includeAIFloatingContextMenu:Boolean=false,$includePresenceSettings:Boolean=false,$includeLoom:Boolean=false,$includeMeetingRecorderEligibility:Boolean!){...loomPersonalization_entryPoints@include(if:$includeLoom)\n  ...loomPersonalization_tenant@include(if:$includeLoom),space(key:$spaceKey)@include(if:$includeRecommendations){id}\n  getRecommendedPages(entityType:$recommendationEntityType,entityId:$contentId,experience:$recommendationExperience)@include(if:$includeRecommendations){...EndOfPageRecommendation_recommendedPagesReader}\n  getRecommendedPagesSpaceStatus(entityId:$recommendationSpaceId)@include(if:$includeRecommendations){...EndOfPageRecommendation_spaceStatusReader},onboardingState(key:$onboardingKeys)@include(if:$includeOnboardingState){...onboardingState_state},catchupGetLastViewedTime(contentId:$contentId,contentType:$catchupContentType)@include(if:$includeAIFloatingContextMenu){...useDynamicSplitButton_catchupLastViewedTimeReader},confluence_teamPresenceContentSetting(cloudId:$cloudId,spaceKey:$spaceKey)@include(if:$includePresenceSettings){...ContentHeaderPresence_contentSettingReader}}fragment ContentHeaderPresence_contentSettingReader on ConfluenceTeamPresence{isEnabledOnContentView}fragment EndOfPageRecommendation_recommendedPagesReader on RecommendedPages{recommendedPages{content{id,title,type,subType,creatorId,links{webui},history{ownedBy{__typename,displayName}},space{id,key,name},emoji:properties(key:\"emoji-title-published\"){nodes{id,key,value}}},strategy}}fragment EndOfPageRecommendation_spaceStatusReader on RecommendedPagesSpaceStatus{recommendedPagesEnabled,defaultBehavior}fragment loomPersonalization_entryPoints on Query{confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled},loom_settings(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){meetingRecordingsAvailable,meetingNotesEligible}\n  loom_connectedCalendars(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){guid}}fragment loomPersonalization_tenant on Query{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}fragment onboardingState_state on OnboardingState{key,value}fragment useDynamicSplitButton_catchupLastViewedTimeReader on CatchupLastViewedTimeResponse{lastViewedTimeISO}"
  }
};
})();

(node as any).hash = "2317e847bd4a7be5764c66d64e219490";

export default node;
